import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Autocomplete from "@mui/material/Autocomplete";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { useAppProvider } from "../Providers/appProvider/AppProvider";
import { useAuth } from "../Providers/AuthProvider";

import { userServiceBaseUrl } from "../config";

import BangDBLogo from "../assets/BangDBIcon.png";

export function Logomark(props) {
  return <img src={BangDBLogo} alt="BangDB" className={props.className} />;
}

export function Logo(props) {
  return (
    <div className={`${props.className} flex items-center`}>
      <img src={BangDBLogo} alt="BangDB" className="h-full w-auto" />
      <span className="text-lg font-semibold">BangDB</span>
      <span className="text-lg px-2 text-blue-600">|</span>
      <span className="text-lg">Store</span>
    </div>
  );
}

export function NavBar() {
  const { userInfo, logout } = useAuth();
  const [anchorElUserMenu, setAnchorElUserMenu] = useState(null);
  const [options, setOptions] = useState([]);
  // null, not "" - MUI matches the value against options and warns on ""
  const [val, setVal] = useState(null);

  const { state } = useAppProvider();
  const {
    appDetails: { appDetails }
  } = state;

  const navigate = useNavigate();

  useEffect(() => {
    setOptions(
      appDetails?.map((item) => ({
        label: item.name || item.appid,
        appid: item.appid
      }))
    );
  }, [appDetails]);

  function handleCloseUserMenu() {
    setAnchorElUserMenu(null);
  }

  function handleOpenUserMenu(event) {
    setAnchorElUserMenu(event.currentTarget);
  }

  const mediaBucket = "user_service_media_bucket";

  return (
    <>
      <header className="bg-slate-50 fixed z-[100] w-full border-b">
        {/*  */}
        <nav>
          <div className="relative z-[100] flex justify-between py-4 mx-auto max-w-[1500px] px-4 sm:px-6 lg:px-8">
            <div className="relative z-10 flex items-center">
              <Link to="/" aria-label="Home">
                <Logo className="h-10 w-auto" />
              </Link>
            </div>
            <div className="flex items-center">
              <Autocomplete
                className="max-sm:hidden"
                disablePortal
                value={val}
                id="combo-box-demo"
                options={options}
                onChange={(e, newVal) => {
                  setVal(newVal);

                  if (newVal?.appid) {
                    navigate(`/detail/${newVal.appid}`);
                  }
                }}
                sx={{ width: 300, bgcolor: "white", mx: 2 }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search"
                    size="small"
                    // label="Search"
                  />
                )}
              />

              <Tooltip title="Profile">
                <IconButton
                  sx={{
                    p: 0
                  }}
                  onClick={handleOpenUserMenu}
                >
                  <Avatar
                    alt={userInfo.first_name}
                    src={`https://${userServiceBaseUrl}/brs/get/123/${mediaBucket}/${userInfo?.userid}_pic`}
                  />
                </IconButton>
              </Tooltip>

              <Menu
                sx={{
                  mt: "45px"
                }}
                id="menu-appbar"
                anchorEl={anchorElUserMenu}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={Boolean(anchorElUserMenu)}
                onClose={handleCloseUserMenu}
              >
                {userInfo.userid ? (
                  <div>
                    <Link to={`/account`}>
                      <MenuItem>
                        <Typography textAlign="center">Profile</Typography>
                      </MenuItem>
                    </Link>
                    <MenuItem onClick={logout}>
                      <Typography textAlign="center">Logout</Typography>
                    </MenuItem>
                  </div>
                ) : (
                  <div>
                    <MenuItem onClick={() => navigate(`/auth/login`)}>
                      <Typography textAlign="center">Login</Typography>
                    </MenuItem>
                  </div>
                )}
              </Menu>
            </div>
          </div>
        </nav>
      </header>
      {/* <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "#012060",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                mr: 2,
                flexGrow: 1,
                display: {
                  xs: "none",
                  md: "flex",
                },
              }}
            >
              <Link to={`/`}>
                <img src={logo} alt="logo" />
              </Link>
            </Typography>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                flexGrow: 1,
                display: {
                  xs: "flex",
                  md: "none",
                },
              }}
            >
              <img src={logo} alt="logo" />
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyItems: "center",
                flexGrow: 0,
              }}
            >
              <Box sx={{ mx: "1rem" }}>
                <Autocomplete
                  disablePortal
                  value={null}
                  id="combo-box-demo"
                  options={options}
                  onChange={(e, newVal) => {
                    if (newVal?.appid && newVal?.appid !== "") {
                      navigate(`/detail/${newVal.appid}`);
                    }
                  }}
                  sx={{ width: 300, bgcolor: "white" }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search"
                      size="small"
                      // label="Search"
                    />
                  )}
                />
              </Box>
              
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar /> */}
    </>
  );
}
